export default __webpack_public_path__ + "static/media/business_pass_white.99077cb1.png";